/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MicrosoftAspNetCoreMvcProblemDetails } from '../model/microsoftAspNetCoreMvcProblemDetails';
import { ModulesCoursesApplicationCourseStatsCourseStatsSummaryResponse } from '../model/modulesCoursesApplicationCourseStatsCourseStatsSummaryResponse';
import { ModulesCoursesApplicationCoursesCourseResponse } from '../model/modulesCoursesApplicationCoursesCourseResponse';
import { ModulesCoursesApplicationHoleYardagesHoleYardageResponse } from '../model/modulesCoursesApplicationHoleYardagesHoleYardageResponse';
import { ModulesCoursesApplicationHolesHoleResponse } from '../model/modulesCoursesApplicationHolesHoleResponse';
import { ModulesCoursesApplicationTeeboxesTeeboxResponse } from '../model/modulesCoursesApplicationTeeboxesTeeboxResponse';
import { ModulesCoursesEndpointsContractsCoursesCreateCourseRequest } from '../model/modulesCoursesEndpointsContractsCoursesCreateCourseRequest';
import { ModulesCoursesEndpointsContractsCoursesUpdateCourseRequestModel } from '../model/modulesCoursesEndpointsContractsCoursesUpdateCourseRequestModel';
import { ModulesCoursesEndpointsContractsHoleYardagesCreateHoleYardageRequestModel } from '../model/modulesCoursesEndpointsContractsHoleYardagesCreateHoleYardageRequestModel';
import { ModulesCoursesEndpointsContractsHoleYardagesHoleYardageRequest } from '../model/modulesCoursesEndpointsContractsHoleYardagesHoleYardageRequest';
import { ModulesCoursesEndpointsContractsHoleYardagesUpdateHoleYardageRequestModel } from '../model/modulesCoursesEndpointsContractsHoleYardagesUpdateHoleYardageRequestModel';
import { ModulesCoursesEndpointsContractsHolesCreateHoleRequestModel } from '../model/modulesCoursesEndpointsContractsHolesCreateHoleRequestModel';
import { ModulesCoursesEndpointsContractsHolesUpdateHoleRequestModel } from '../model/modulesCoursesEndpointsContractsHolesUpdateHoleRequestModel';
import { ModulesCoursesEndpointsContractsTeeboxesCreateTeeboxRequestModel } from '../model/modulesCoursesEndpointsContractsTeeboxesCreateTeeboxRequestModel';
import { ModulesCoursesEndpointsContractsTeeboxesUpdateTeeboxRequestModel } from '../model/modulesCoursesEndpointsContractsTeeboxesUpdateTeeboxRequestModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { CoursesServiceInterface }                            from './courses.serviceInterface';


@Injectable()
export class CoursesService implements CoursesServiceInterface {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Removes a Course.
     * Removes a Course using the Course identifier.
     * @param courseId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public coursesCourseIdDelete(courseId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public coursesCourseIdDelete(courseId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public coursesCourseIdDelete(courseId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public coursesCourseIdDelete(courseId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling coursesCourseIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/courses/${encodeURIComponent(String(courseId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes all Holes.
     * Removes all Holes for a Course using the Course identifier.
     * @param courseId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public coursesCourseIdHolesDelete(courseId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public coursesCourseIdHolesDelete(courseId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public coursesCourseIdHolesDelete(courseId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public coursesCourseIdHolesDelete(courseId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling coursesCourseIdHolesDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/courses/${encodeURIComponent(String(courseId))}/holes`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes a Hole.
     * Removes a Hole by the Course and Hole identifiers.
     * @param holeId 
     * @param courseId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public coursesCourseIdHolesHoleIdDelete(holeId: string, courseId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public coursesCourseIdHolesHoleIdDelete(holeId: string, courseId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public coursesCourseIdHolesHoleIdDelete(holeId: string, courseId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public coursesCourseIdHolesHoleIdDelete(holeId: string, courseId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (holeId === null || holeId === undefined) {
            throw new Error('Required parameter holeId was null or undefined when calling coursesCourseIdHolesHoleIdDelete.');
        }

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling coursesCourseIdHolesHoleIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/courses/${encodeURIComponent(String(courseId))}/holes/${encodeURIComponent(String(holeId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes a HoleYardage.
     * Removes a HoleYardage by the HoleYardage identifier.
     * @param holeId 
     * @param courseId 
     * @param holeYardageId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public coursesCourseIdHolesHoleIdHoleYardagesHoleYardageIdDelete(holeId: string, courseId: string, holeYardageId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public coursesCourseIdHolesHoleIdHoleYardagesHoleYardageIdDelete(holeId: string, courseId: string, holeYardageId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public coursesCourseIdHolesHoleIdHoleYardagesHoleYardageIdDelete(holeId: string, courseId: string, holeYardageId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public coursesCourseIdHolesHoleIdHoleYardagesHoleYardageIdDelete(holeId: string, courseId: string, holeYardageId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (holeId === null || holeId === undefined) {
            throw new Error('Required parameter holeId was null or undefined when calling coursesCourseIdHolesHoleIdHoleYardagesHoleYardageIdDelete.');
        }

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling coursesCourseIdHolesHoleIdHoleYardagesHoleYardageIdDelete.');
        }

        if (holeYardageId === null || holeYardageId === undefined) {
            throw new Error('Required parameter holeYardageId was null or undefined when calling coursesCourseIdHolesHoleIdHoleYardagesHoleYardageIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/courses/${encodeURIComponent(String(courseId))}/holes/${encodeURIComponent(String(holeId))}/holeYardages/${encodeURIComponent(String(holeYardageId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a HoleYardage.
     * Updates a HoleYardage based on the HoleYardage identifier and the UpdateHoleYardageRequest.
     * @param holeId 
     * @param courseId 
     * @param holeYardageId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public coursesCourseIdHolesHoleIdHoleYardagesHoleYardageIdPut(holeId: string, courseId: string, holeYardageId: string, body?: ModulesCoursesEndpointsContractsHoleYardagesUpdateHoleYardageRequestModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public coursesCourseIdHolesHoleIdHoleYardagesHoleYardageIdPut(holeId: string, courseId: string, holeYardageId: string, body?: ModulesCoursesEndpointsContractsHoleYardagesUpdateHoleYardageRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public coursesCourseIdHolesHoleIdHoleYardagesHoleYardageIdPut(holeId: string, courseId: string, holeYardageId: string, body?: ModulesCoursesEndpointsContractsHoleYardagesUpdateHoleYardageRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public coursesCourseIdHolesHoleIdHoleYardagesHoleYardageIdPut(holeId: string, courseId: string, holeYardageId: string, body?: ModulesCoursesEndpointsContractsHoleYardagesUpdateHoleYardageRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (holeId === null || holeId === undefined) {
            throw new Error('Required parameter holeId was null or undefined when calling coursesCourseIdHolesHoleIdHoleYardagesHoleYardageIdPut.');
        }

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling coursesCourseIdHolesHoleIdHoleYardagesHoleYardageIdPut.');
        }

        if (holeYardageId === null || holeYardageId === undefined) {
            throw new Error('Required parameter holeYardageId was null or undefined when calling coursesCourseIdHolesHoleIdHoleYardagesHoleYardageIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/courses/${encodeURIComponent(String(courseId))}/holes/${encodeURIComponent(String(holeId))}/holeYardages/${encodeURIComponent(String(holeYardageId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a HoleYardage.
     * Creates a HoleYardage based on the Hole identifier and the CreateHoleYardageRequest.
     * @param courseId 
     * @param holeId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public coursesCourseIdHolesHoleIdHoleYardagesPost(courseId: string, holeId: string, body?: ModulesCoursesEndpointsContractsHoleYardagesCreateHoleYardageRequestModel, observe?: 'body', reportProgress?: boolean): Observable<ModulesCoursesEndpointsContractsHoleYardagesHoleYardageRequest>;
    public coursesCourseIdHolesHoleIdHoleYardagesPost(courseId: string, holeId: string, body?: ModulesCoursesEndpointsContractsHoleYardagesCreateHoleYardageRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesCoursesEndpointsContractsHoleYardagesHoleYardageRequest>>;
    public coursesCourseIdHolesHoleIdHoleYardagesPost(courseId: string, holeId: string, body?: ModulesCoursesEndpointsContractsHoleYardagesCreateHoleYardageRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesCoursesEndpointsContractsHoleYardagesHoleYardageRequest>>;
    public coursesCourseIdHolesHoleIdHoleYardagesPost(courseId: string, holeId: string, body?: ModulesCoursesEndpointsContractsHoleYardagesCreateHoleYardageRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling coursesCourseIdHolesHoleIdHoleYardagesPost.');
        }

        if (holeId === null || holeId === undefined) {
            throw new Error('Required parameter holeId was null or undefined when calling coursesCourseIdHolesHoleIdHoleYardagesPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ModulesCoursesEndpointsContractsHoleYardagesHoleYardageRequest>('post',`${this.basePath}/courses/${encodeURIComponent(String(courseId))}/holes/${encodeURIComponent(String(holeId))}/holeYardages`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a Hole.
     * Updates a Hole for a Course using the UpdateHoleRequest.
     * @param holeId 
     * @param courseId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public coursesCourseIdHolesHoleIdPut(holeId: string, courseId: string, body?: ModulesCoursesEndpointsContractsHolesUpdateHoleRequestModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public coursesCourseIdHolesHoleIdPut(holeId: string, courseId: string, body?: ModulesCoursesEndpointsContractsHolesUpdateHoleRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public coursesCourseIdHolesHoleIdPut(holeId: string, courseId: string, body?: ModulesCoursesEndpointsContractsHolesUpdateHoleRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public coursesCourseIdHolesHoleIdPut(holeId: string, courseId: string, body?: ModulesCoursesEndpointsContractsHolesUpdateHoleRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (holeId === null || holeId === undefined) {
            throw new Error('Required parameter holeId was null or undefined when calling coursesCourseIdHolesHoleIdPut.');
        }

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling coursesCourseIdHolesHoleIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/courses/${encodeURIComponent(String(courseId))}/holes/${encodeURIComponent(String(holeId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a Hole.
     * Creates a Hole based on the Course identifier and the CreateHoleRequest.
     * @param courseId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public coursesCourseIdHolesPost(courseId: string, body?: ModulesCoursesEndpointsContractsHolesCreateHoleRequestModel, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public coursesCourseIdHolesPost(courseId: string, body?: ModulesCoursesEndpointsContractsHolesCreateHoleRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public coursesCourseIdHolesPost(courseId: string, body?: ModulesCoursesEndpointsContractsHolesCreateHoleRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public coursesCourseIdHolesPost(courseId: string, body?: ModulesCoursesEndpointsContractsHolesCreateHoleRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling coursesCourseIdHolesPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/courses/${encodeURIComponent(String(courseId))}/holes`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a Course.
     * Updates a Course based on the Course idenfier and UpdateCourseRequest.
     * @param courseId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public coursesCourseIdPut(courseId: string, body?: ModulesCoursesEndpointsContractsCoursesUpdateCourseRequestModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public coursesCourseIdPut(courseId: string, body?: ModulesCoursesEndpointsContractsCoursesUpdateCourseRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public coursesCourseIdPut(courseId: string, body?: ModulesCoursesEndpointsContractsCoursesUpdateCourseRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public coursesCourseIdPut(courseId: string, body?: ModulesCoursesEndpointsContractsCoursesUpdateCourseRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling coursesCourseIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/courses/${encodeURIComponent(String(courseId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes all Teeboxes.
     * Removes all Teeboxes for a Course by the Course identifier.
     * @param courseId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public coursesCourseIdTeeboxesDelete(courseId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public coursesCourseIdTeeboxesDelete(courseId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public coursesCourseIdTeeboxesDelete(courseId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public coursesCourseIdTeeboxesDelete(courseId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling coursesCourseIdTeeboxesDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/courses/${encodeURIComponent(String(courseId))}/teeboxes`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a Teebox.
     * Creates a Teebox based on the Course identifier and the CreateTeeboxRequest.
     * @param courseId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public coursesCourseIdTeeboxesPost(courseId: string, body?: ModulesCoursesEndpointsContractsTeeboxesCreateTeeboxRequestModel, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public coursesCourseIdTeeboxesPost(courseId: string, body?: ModulesCoursesEndpointsContractsTeeboxesCreateTeeboxRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public coursesCourseIdTeeboxesPost(courseId: string, body?: ModulesCoursesEndpointsContractsTeeboxesCreateTeeboxRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public coursesCourseIdTeeboxesPost(courseId: string, body?: ModulesCoursesEndpointsContractsTeeboxesCreateTeeboxRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling coursesCourseIdTeeboxesPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('post',`${this.basePath}/courses/${encodeURIComponent(String(courseId))}/teeboxes`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes a Teebox.
     * Removes a Teebox by the Course and Teebox identifiers.
     * @param courseId 
     * @param teeboxId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public coursesCourseIdTeeboxesTeeboxIdDelete(courseId: string, teeboxId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public coursesCourseIdTeeboxesTeeboxIdDelete(courseId: string, teeboxId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public coursesCourseIdTeeboxesTeeboxIdDelete(courseId: string, teeboxId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public coursesCourseIdTeeboxesTeeboxIdDelete(courseId: string, teeboxId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling coursesCourseIdTeeboxesTeeboxIdDelete.');
        }

        if (teeboxId === null || teeboxId === undefined) {
            throw new Error('Required parameter teeboxId was null or undefined when calling coursesCourseIdTeeboxesTeeboxIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/courses/${encodeURIComponent(String(courseId))}/teeboxes/${encodeURIComponent(String(teeboxId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a Teebox.
     * Updates a Teebox for a Course based on the Course and Teexbox identifiers and UpdateTeeboxRequest.
     * @param courseId 
     * @param teeboxId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public coursesCourseIdTeeboxesTeeboxIdPut(courseId: string, teeboxId: string, body?: ModulesCoursesEndpointsContractsTeeboxesUpdateTeeboxRequestModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public coursesCourseIdTeeboxesTeeboxIdPut(courseId: string, teeboxId: string, body?: ModulesCoursesEndpointsContractsTeeboxesUpdateTeeboxRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public coursesCourseIdTeeboxesTeeboxIdPut(courseId: string, teeboxId: string, body?: ModulesCoursesEndpointsContractsTeeboxesUpdateTeeboxRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public coursesCourseIdTeeboxesTeeboxIdPut(courseId: string, teeboxId: string, body?: ModulesCoursesEndpointsContractsTeeboxesUpdateTeeboxRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling coursesCourseIdTeeboxesTeeboxIdPut.');
        }

        if (teeboxId === null || teeboxId === undefined) {
            throw new Error('Required parameter teeboxId was null or undefined when calling coursesCourseIdTeeboxesTeeboxIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/courses/${encodeURIComponent(String(courseId))}/teeboxes/${encodeURIComponent(String(teeboxId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a Course.
     * Creates a Course based on the CreateCourseRequest request.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public coursesPost(body?: ModulesCoursesEndpointsContractsCoursesCreateCourseRequest, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public coursesPost(body?: ModulesCoursesEndpointsContractsCoursesCreateCourseRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public coursesPost(body?: ModulesCoursesEndpointsContractsCoursesCreateCourseRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public coursesPost(body?: ModulesCoursesEndpointsContractsCoursesCreateCourseRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/courses`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a Course.
     * Gets a Course using the Course identifier.
     * @param courseId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCourseByIdEndpoint(courseId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesCoursesApplicationCoursesCourseResponse>;
    public getCourseByIdEndpoint(courseId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesCoursesApplicationCoursesCourseResponse>>;
    public getCourseByIdEndpoint(courseId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesCoursesApplicationCoursesCourseResponse>>;
    public getCourseByIdEndpoint(courseId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling getCourseByIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesCoursesApplicationCoursesCourseResponse>('get',`${this.basePath}/courses/${encodeURIComponent(String(courseId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets course statistics summary.
     * Gets per-hole and section course statistics for tournament/course/round.
     * @param tournamentId 
     * @param courseId 
     * @param roundId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCourseStatsEndpoint(tournamentId: number, courseId: number, roundId: number, observe?: 'body', reportProgress?: boolean): Observable<ModulesCoursesApplicationCourseStatsCourseStatsSummaryResponse>;
    public getCourseStatsEndpoint(tournamentId: number, courseId: number, roundId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesCoursesApplicationCourseStatsCourseStatsSummaryResponse>>;
    public getCourseStatsEndpoint(tournamentId: number, courseId: number, roundId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesCoursesApplicationCourseStatsCourseStatsSummaryResponse>>;
    public getCourseStatsEndpoint(tournamentId: number, courseId: number, roundId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling getCourseStatsEndpoint.');
        }

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling getCourseStatsEndpoint.');
        }

        if (roundId === null || roundId === undefined) {
            throw new Error('Required parameter roundId was null or undefined when calling getCourseStatsEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesCoursesApplicationCourseStatsCourseStatsSummaryResponse>('get',`${this.basePath}/courses/stats/${encodeURIComponent(String(tournamentId))}/${encodeURIComponent(String(courseId))}/${encodeURIComponent(String(roundId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets all Courses.
     * Gets all Courses.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCoursesEndpoint(observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesCoursesApplicationCoursesCourseResponse>>;
    public getCoursesEndpoint(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesCoursesApplicationCoursesCourseResponse>>>;
    public getCoursesEndpoint(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesCoursesApplicationCoursesCourseResponse>>>;
    public getCoursesEndpoint(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesCoursesApplicationCoursesCourseResponse>>('get',`${this.basePath}/courses`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a Hole.
     * Gets a Hole by the Course and Hole identifiers.
     * @param holeId 
     * @param courseId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getHoleByIdEndpoint(holeId: string, courseId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesCoursesApplicationHolesHoleResponse>;
    public getHoleByIdEndpoint(holeId: string, courseId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesCoursesApplicationHolesHoleResponse>>;
    public getHoleByIdEndpoint(holeId: string, courseId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesCoursesApplicationHolesHoleResponse>>;
    public getHoleByIdEndpoint(holeId: string, courseId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (holeId === null || holeId === undefined) {
            throw new Error('Required parameter holeId was null or undefined when calling getHoleByIdEndpoint.');
        }

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling getHoleByIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesCoursesApplicationHolesHoleResponse>('get',`${this.basePath}/courses/${encodeURIComponent(String(courseId))}/holes/${encodeURIComponent(String(holeId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a HoleYardage.
     * Gets a HoleYardage using the HoleYardage identifier.
     * @param holeId 
     * @param courseId 
     * @param holeYardageId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getHoleYardageByIdEndpoint(holeId: string, courseId: string, holeYardageId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesCoursesApplicationHoleYardagesHoleYardageResponse>;
    public getHoleYardageByIdEndpoint(holeId: string, courseId: string, holeYardageId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesCoursesApplicationHoleYardagesHoleYardageResponse>>;
    public getHoleYardageByIdEndpoint(holeId: string, courseId: string, holeYardageId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesCoursesApplicationHoleYardagesHoleYardageResponse>>;
    public getHoleYardageByIdEndpoint(holeId: string, courseId: string, holeYardageId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (holeId === null || holeId === undefined) {
            throw new Error('Required parameter holeId was null or undefined when calling getHoleYardageByIdEndpoint.');
        }

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling getHoleYardageByIdEndpoint.');
        }

        if (holeYardageId === null || holeYardageId === undefined) {
            throw new Error('Required parameter holeYardageId was null or undefined when calling getHoleYardageByIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesCoursesApplicationHoleYardagesHoleYardageResponse>('get',`${this.basePath}/courses/${encodeURIComponent(String(courseId))}/holes/${encodeURIComponent(String(holeId))}/holeYardages/${encodeURIComponent(String(holeYardageId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets HoleYardages for a Course.
     * Gets HoleYardages for a Course using the Course identifier.
     * @param courseId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getHoleYardagesByCourseIdEndpoint(courseId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesCoursesApplicationHoleYardagesHoleYardageResponse>>;
    public getHoleYardagesByCourseIdEndpoint(courseId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesCoursesApplicationHoleYardagesHoleYardageResponse>>>;
    public getHoleYardagesByCourseIdEndpoint(courseId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesCoursesApplicationHoleYardagesHoleYardageResponse>>>;
    public getHoleYardagesByCourseIdEndpoint(courseId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling getHoleYardagesByCourseIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesCoursesApplicationHoleYardagesHoleYardageResponse>>('get',`${this.basePath}/courses/${encodeURIComponent(String(courseId))}/holeYardages`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets Hole HoleYardages.
     * Gets HoleYardages using the Hole identifier.
     * @param holeId 
     * @param courseId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getHoleYardagesByHoleIdEndpoint(holeId: string, courseId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesCoursesApplicationHoleYardagesHoleYardageResponse>>;
    public getHoleYardagesByHoleIdEndpoint(holeId: string, courseId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesCoursesApplicationHoleYardagesHoleYardageResponse>>>;
    public getHoleYardagesByHoleIdEndpoint(holeId: string, courseId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesCoursesApplicationHoleYardagesHoleYardageResponse>>>;
    public getHoleYardagesByHoleIdEndpoint(holeId: string, courseId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (holeId === null || holeId === undefined) {
            throw new Error('Required parameter holeId was null or undefined when calling getHoleYardagesByHoleIdEndpoint.');
        }

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling getHoleYardagesByHoleIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesCoursesApplicationHoleYardagesHoleYardageResponse>>('get',`${this.basePath}/courses/${encodeURIComponent(String(courseId))}/holes/${encodeURIComponent(String(holeId))}/holeYardages`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets all Holes.
     * Gets all Holes for a Course using the Course identifier.
     * @param courseId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getHolesByCourseIdEndpoint(courseId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesCoursesApplicationHolesHoleResponse>>;
    public getHolesByCourseIdEndpoint(courseId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesCoursesApplicationHolesHoleResponse>>>;
    public getHolesByCourseIdEndpoint(courseId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesCoursesApplicationHolesHoleResponse>>>;
    public getHolesByCourseIdEndpoint(courseId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling getHolesByCourseIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesCoursesApplicationHolesHoleResponse>>('get',`${this.basePath}/courses/${encodeURIComponent(String(courseId))}/holes`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a Teebox.
     * Gets a Teebox using the Course and Teebox identifiers.
     * @param courseId 
     * @param teeboxId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTeeboxByIdEndpoint(courseId: string, teeboxId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesCoursesApplicationTeeboxesTeeboxResponse>;
    public getTeeboxByIdEndpoint(courseId: string, teeboxId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesCoursesApplicationTeeboxesTeeboxResponse>>;
    public getTeeboxByIdEndpoint(courseId: string, teeboxId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesCoursesApplicationTeeboxesTeeboxResponse>>;
    public getTeeboxByIdEndpoint(courseId: string, teeboxId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling getTeeboxByIdEndpoint.');
        }

        if (teeboxId === null || teeboxId === undefined) {
            throw new Error('Required parameter teeboxId was null or undefined when calling getTeeboxByIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesCoursesApplicationTeeboxesTeeboxResponse>('get',`${this.basePath}/courses/${encodeURIComponent(String(courseId))}/teeboxes/${encodeURIComponent(String(teeboxId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets all Teeboxes .
     * Gets all Teeboxes for a Course using the Course identifier.
     * @param courseId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTeeboxesByCourseIdEndpoint(courseId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesCoursesApplicationTeeboxesTeeboxResponse>>;
    public getTeeboxesByCourseIdEndpoint(courseId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesCoursesApplicationTeeboxesTeeboxResponse>>>;
    public getTeeboxesByCourseIdEndpoint(courseId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesCoursesApplicationTeeboxesTeeboxResponse>>>;
    public getTeeboxesByCourseIdEndpoint(courseId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling getTeeboxesByCourseIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesCoursesApplicationTeeboxesTeeboxResponse>>('get',`${this.basePath}/courses/${encodeURIComponent(String(courseId))}/teeboxes`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
